import { storage } from "./firebase";

// *** Storage
export const storageRef = (userId: string) => storage.ref(userId);
